/* eslint-disable class-methods-use-this */

// Note: RevenueCat's Purchases plugin doesn't come with a web implementation
// so creating this interface so that plugin calls work on web as well
// Until Stripe support added, can't make purchases on web

import { WebPlugin, registerWebPlugin } from '@capacitor/core';
import axios from 'axios';

class PurchasesPluginWeb extends WebPlugin {
  constructor() {
    super({
      name: 'PurchasesPlugin',
      platforms: ['web'],
    });
    this.userId = '';
    this.publicKey = '';
    this.entitlementId1 = '';
    this.entitlementId2 = '';
  }

  setup({ publicKey, userId, entitlementId1, entitlementId2 }) {
    const testId = 'Tmp2VWUyJxXIYjfmutiTspzOifW2';
    this.userId = testId;
    // this.userId = userId;
    this.publicKey = publicKey;
    this.entitlementId1 = entitlementId1;
    this.entitlementId2 = entitlementId2;
  }

  async getPurchaserInfo() {
    const { userId, publicKey, entitlementId1, entitlementId2 } = this;
    if (!userId || !publicKey) {
      throw new Error(`Purchases Web Puglin: API not set up with userId or publicKey`);
    }
    try {
      const { data } = await axios.get(`https://api.revenuecat.com/v1/subscribers/${this.userId}`, {
        headers: {
          authorization: `Bearer ${this.publicKey}`,
          'content-type': 'application/json',
          'x-platform': 'stripe',
        },
      });

      // Only active subscriptions included in entitlements object
      const activeEntitlements = data.subscriber.entitlements;
      const entitlement1IsActive = entitlementId1 in activeEntitlements;
      const entitlement2IsActive = entitlementId2 in activeEntitlements;

      let memberLevel = 0;
      if (entitlement1IsActive) memberLevel = 1;
      if (entitlement2IsActive) memberLevel = 2;

      let subscription = {};
      const entitlementId = entitlement2IsActive ? entitlementId2 : entitlementId1;
      const apiEntitlement =
        activeEntitlements[entitlementId2] || activeEntitlements[entitlementId1];

      if (apiEntitlement) {
        const productIdentifier = apiEntitlement.product_identifier;
        const apiSub = data.subscriber.subscriptions[productIdentifier];

        subscription = {
          billingIssueDetectedAt: apiSub.billing_issues_detected_at,
          expirationDate: apiSub.expires_date,
          identifier: entitlementId,
          isActive: true,
          isSandbox: apiSub.is_sandbox,
          latestPurchaseDate: apiSub.purchase_date,
          originalPurchaseDate: apiSub.original_purchase_date,
          periodType: apiSub.period_type,
          productIdentifier,
          store: apiSub.store,
          unsubscribeDetectedAt: apiSub.unsubscribe_detected_at,
        };
      }
      return { memberLevel, subscription };
    } catch (error) {
      throw new Error(`Can't get purchaser info: ${error}`);
    }
  }

  checkIfCanMakePurchases() {
    return { canMakePurchases: false };
  }

  getPackages() {
    // TESTING Only return data for testing
    /* eslint-disable no-use-before-define */
    // return testAnnualPackage;

    throw new Error(`Can't get offerings from web`);
  }

  purchasePackage() {
    // TESTING Only return data for testing
    /* eslint-disable no-use-before-define */
    // return testNewPurchaserInfo;

    throw new Error(`Can't purchase from web`);
  }

  restorePurchases() {
    throw new Error(`Can't restore purchases from web`);
  }

  resetUser() {
    this.userId = '';
  }
}

// Instantiate the plugin
const PurchasesPlugin = new PurchasesPluginWeb();

registerWebPlugin(PurchasesPlugin);

/* 
  DUMMY DATA TO MIMIC SDK
*/

// const testAnnualPackage = {
//   identifier: '$rc_annual',
//   packageType: 'ANNUAL',
//   product: {
//     identifier: 'subscription_annual',
//     price: 17.49,
//     priceString: '$17.49',
//     currencyCode: 'USD',
//     freeTrialPeriod: 'P1W',
//     introPrice: 0,
//     introPricePeriod: 'P1W',
//     introPriceCycles: 1,
//   },
// };

// const testNewPurchaserInfo = {
//   hasActiveSubscription: true,
//   subscription: {
//     identifier: 'subscription',
//     isActive: true,
//     willRenew: true,
//     periodType: 'TRIAL',
//     latestPurchaseDate: '2020-06-21T19:00:59.000Z',
//     originalPurchaseDate: '2020-06-21T19:00:59.000Z',
//     expirationDate: '2020-06-21T19:05:23.000Z',
//     store: 'PLAY_STORE',
//     productIdentifier: 'subscription_annual',
//     isSandbox: true,
//     unsubscribeDetectedAt: null,
//     billingIssueDetectedAt: null,
//   },
// };

/*
  SAMPLE API RESPONSES

  ** Get Subscriber **

  subscriber:
    entitlements:
      subscription:
        expires_date: "2220-05-02T18:48:44Z"
        product_identifier: "rc_promo_subscription_lifetime"
        purchase_date: "2020-06-19T18:48:44Z"
    first_seen: "2020-06-19T18:45:52Z"
    last_seen: "2020-06-19T18:45:52Z"
    management_url: null
    non_subscriptions: {}
    original_app_user_id: "RNhLecAM7jhO0x7ID1Y22exvglF2"
    original_application_version: null
    original_purchase_date: null
    other_purchases: {}
    subscriptions:
      rc_promo_subscription_lifetime:
        billing_issues_detected_at: null
        expires_date: "2220-05-02T18:48:44Z"
        is_sandbox: false
        original_purchase_date: "2020-06-19T18:48:44Z"
        period_type: "normal"
        purchase_date: "2020-06-19T18:48:44Z"
        store: "promotional"
        unsubscribe_detected_at: null

*/
